export const getSignedImageUrl = async (path) => {
    if (!path) return null;

    const cacheKey = `wasabi_url_${path}`;
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) return JSON.parse(cached);

    try {
        const res = await fetch('https://jokkkjuvydarwembwfuj.supabase.co/functions/v1/get-wasabi-signed-url', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ path })
        });

        const data = await res.json();
        if (data.url) sessionStorage.setItem(cacheKey, JSON.stringify(data.url));
        return data.url || null;
    } catch (error) {
        console.error('Signed URL error:', error);
        return null;
    }
};
